import "./contact.css";
import React, { useState } from "react";
import { sendContact } from "../../services/ContactService";
import PageHeader from "../../components/Elements/PageHeader/PageHeader";
import { Helmet } from "react-helmet";
import MainInput from "../../components/Elements/MainInput/MainInput";
import MainButton from "../../components/Elements/MainButton/MainButton";
import ErrorMessage from "../../components/Elements/ErrorMessage/ErrorMessage";
import SuccessMessage from "../../components/Elements/SuccessMessage/SuccessMessage";

import mapImage from "../../assets/icons/mapa.png";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const validate = () => form.email.trim() && form.message.trim();

  const handleCloseMessage = () => {
    setStatus(null);
    setErrorMsg("");
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      setStatus("error");
      setErrorMsg("Please provide at least Email and Message.");
      return;
    }
    try {
      setStatus("loading");
      setErrorMsg("");
      const resp = await sendContact({
        name: form.name.trim(),
        email: form.email.trim(),
        subject: form.subject.trim(),
        message: form.message.trim(),
      });
      setStatus("success");
      setErrorMsg("Thanks! We'll reply shortly.");
    } catch (err) {
      setStatus("error");
      setErrorMsg(err?.message || "Something went wrong. Try again.");
    }
  };

  return (
    <main className="contact-page">
      <Helmet>
        <title>Telviora - Contact</title>
      </Helmet>
      <PageHeader
        title="Contact Us"
        description="Tell us about your use case. The team responds quickly with practical next steps."
      />

      <section className="contact-page__wrap">
        <form className="contact-form" onSubmit={onSubmit} noValidate aria-labelledby="contactFormTitle">
          <h2 id="contactFormTitle" className="sr-only">
            Contact form
          </h2>

          <div className="field">
            <MainInput
              name="name"
              type="text"
              value={form.name}
              onChange={onChange}
              placeholder="Name"
              autoComplete="name"
            />
          </div>

          <div className="field">
            <MainInput
              name="email"
              type="email"
              value={form.email}
              onChange={onChange}
              placeholder="Email"
              autoComplete="email"
              required
            />
          </div>

          <div className="field">
            <MainInput name="subject" type="text" value={form.subject} onChange={onChange} placeholder="Subject" />
          </div>

          <div className="field">
            <MainInput
              name="message"
              type="textarea"
              value={form.message}
              onChange={onChange}
              placeholder="Message"
              rows={6}
              required
            />
          </div>

          <div className="actions">
            <div className="actions-content">
              <MainButton type="submit" disabled={status === "loading"} className="contact-submit">
                {status === "loading" ? "Sending…" : "Send Message"}
              </MainButton>

              {/* Nowe komponenty po prawej od buttona */}
              {status === "success" && (
                <SuccessMessage message="Thanks! We'll reply shortly." onClose={handleCloseMessage} />
              )}
              {status === "error" && <ErrorMessage message={errorMsg} onClose={handleCloseMessage} />}
            </div>
          </div>
        </form>

        <aside className="contact-info" aria-label="Offices">
          <div className="info-card">
            <h3>Office in Dubai</h3>
            <p>
              Telviora by Mobile World DWC LLC
              <br />
              Dubai South, Dubai, UAE
            </p>
          </div>
          {/* <div className="info-card">
            <h3>Office in Warsaw</h3>
            <p>+48 22 2133900</p>
            <p>ul. Skierniewicka 16/20 01-230 Warszawa, Polska</p>
          </div> */}
          {/* <div className="map-card" aria-label="Map">
            <div className="map-embed">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2175.455479891876!2d23.6012345412162!3d56.95812997366421!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46eee6ce5a603f15%3A0x5caaf518be92ee06!2zU2tvbGFzIGllbGEgMzgsIErFq3JtYWxhLCBMVi0yMDExLCDQm9Cw0YLQstC40Y8!5e0!3m2!1sru!2spl!4v1769443653350!5m2!1sru!2spl"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div> */}
          <div className="map-card" aria-label="Map">
            <div className="map-embed">
              {/* 2. Zmieniono iframe na img */}
              <img
                src={mapImage}
                alt="Map showing office location"
                style={{
                  width: "100%",
                  height: "250px",
                  objectFit: "cover",
                }}
              />
            </div>
          </div>
        </aside>
      </section>
    </main>
  );
}
